import React from 'react';
import _ from 'lodash';
import {formValueSelector} from 'redux-form';

import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';
import Label from 'components/Label';
import FormField from 'components/FormField';
import {SearchRoomField} from 'components/Fields';
import {buildRoomSelectizeOption} from 'components/Fields/SearchRoomField';

import {required} from 'utils/validators';
import {headOption} from 'utils/common';
import {selectModal, MODALS as BASE_MODALS} from 'ducks/modals';

import {BOOKING_TYPE_TO_PURPOSE_TYPE_MAPPER} from 'ducks/bookings';

const NO_AVAILABLE_ROOMS_ERROR =
  'There are no available rooms of this type for the selected dates';

const ROOM_PURPOSE_TYPE_DOES_NOT_CORRESPOND_TO_THE_SELECTED_BOOKING_TYPE =
  'Selected room has purpose type that does not correspond to the selected booking type!';

export const initialValues = state => {
  const modal = selectModal(state, BASE_MODALS.CREATE_BOOKING);
  const formSelector = formValueSelector('createBooking');
  const availableRooms = _.get(modal, 'data.availableRooms', []);
  const selectedBookingType = formSelector(state, 'bookingType.label');

  const selectedAvailableRoom = headOption(
    availableRooms.filter(
      room =>
        _.get(room, 'roomPurposesForPeriod[0].purpose') ===
        BOOKING_TYPE_TO_PURPOSE_TYPE_MAPPER[selectedBookingType]
    ),
    buildRoomSelectizeOption
  );

  return {
    room: selectedAvailableRoom
  };
};

const RoomSection = ({
  availableRooms,
  noAvailableRooms,
  hasNotMatchingRoomPurposeToBookingType,
  availableRoomsAreLoading
}) => (
  <div>
    <FormField>
      <Label>Room</Label>
      <SearchRoomField
        rooms={availableRooms}
        validators={[required]}
        isLoading={availableRoomsAreLoading}
      />
    </FormField>
    {noAvailableRooms && <ErrorBlock>{NO_AVAILABLE_ROOMS_ERROR}</ErrorBlock>}
    {hasNotMatchingRoomPurposeToBookingType && (
      <Warning>
        {ROOM_PURPOSE_TYPE_DOES_NOT_CORRESPOND_TO_THE_SELECTED_BOOKING_TYPE}
      </Warning>
    )}
  </div>
);

export default RoomSection;
